var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAmusementParkThumbnail = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "thumbnail-background",
    x: 0.5,
    y: 0.5,
    width: 101,
    height: 101,
    rx: 10.5,
    fill: "#ABC17D",
    stroke: "#1E1E1E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_78126)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.4736,
    y: 6.88318,
    width: 1.34213,
    height: 12.5266,
    rx: 0.671066,
    fill: "#22343C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0697 11.6925L30.0675 7.9853C29.7627 7.79706 29.3696 8.01629 29.3696 8.37452V13.6706C29.3696 13.9708 29.6539 14.1897 29.9442 14.1128L35.9464 12.524C36.3347 12.4212 36.4115 11.9036 36.0697 11.6925Z",
    fill: "#FFCE63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-roof",
    d: "M28.1974 15.7349C28.3721 15.5129 28.639 15.3833 28.9215 15.3833C29.204 15.3833 29.4708 15.5129 29.6455 15.7349L47.93 38.9714C49.1108 40.472 48.0418 42.6733 46.1324 42.6733H11.7106C9.80112 42.6733 8.73218 40.472 9.91296 38.9714L28.1974 15.7349Z",
    fill: "#F97953"
  }), /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-roof-shadow",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4521 16.7577L29.6473 15.7349C29.4726 15.5129 29.2057 15.3833 28.9232 15.3833C28.6407 15.3833 28.3739 15.5129 28.1992 15.7349L9.91471 38.9714C8.73393 40.472 9.80287 42.6733 11.7123 42.6733H20.7518L30.4521 16.7577Z",
    fill: "#EA462F"
  }), /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-entrance-door",
    d: "M7 36.4101H13.6435V42.226H19.4013V36.4101H26.0448V42.226H31.8026V36.4101H38.4461V42.226H44.6468V36.4101H51.2903V85.1168H40.6606V69.0686H40.6422C40.6544 68.8465 40.6606 68.6227 40.6606 68.3975C40.6606 61.8499 35.4058 56.542 28.9237 56.542C22.4416 56.542 17.1868 61.8499 17.1868 68.3975C17.1868 68.6227 17.193 68.8465 17.2053 69.0686H17.1868V85.1168H7V36.4101Z",
    fill: "#F9DCB9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-entrance-door-shadow",
    d: "M21.7634 36.4101H19.4013V42.226H13.6435V36.4101H7V85.1168H17.1868V69.0686H17.2053C17.193 68.8465 17.1868 68.6227 17.1868 68.3975C17.1868 64.5727 18.9799 61.1709 21.7634 59.0031V36.4101Z",
    fill: "#F5C58A"
  }), /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-smoke",
    d: "M68.1227 49.418C65.4245 48.6852 63.4414 46.233 63.4414 43.3207C63.4414 39.8299 66.2906 37 69.8053 37C72.8497 37 75.3948 39.1232 76.0214 41.9601C76.0988 41.9561 76.1768 41.954 76.2552 41.954C78.6775 41.954 80.6411 43.9043 80.6411 46.3102C80.6411 48.5723 78.905 50.4317 76.6839 50.6458C76.6848 50.681 76.6852 50.7163 76.6852 50.7517C76.6852 53.1575 74.7216 55.1078 72.2993 55.1078C69.877 55.1078 67.9133 53.1575 67.9133 50.7517C67.9133 50.2865 67.9867 49.8384 68.1227 49.418Z",
    fill: "#A4D0DA"
  }), /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-train-detail",
    d: "M67.9131 56.3036H77.2009L76.6849 64.1618H68.6011L67.9131 56.3036Z",
    fill: "#18252C"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "thumbnail-train-detail",
    x: 29,
    y: 82.9626,
    width: 56.2871,
    height: 6.3891,
    fill: "#18252C"
  }), /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-train-detail",
    d: "M94.7854 92.7937L85.9606 83.6225C85.8308 83.4876 85.6517 83.4114 85.4645 83.4114H80.6652C80.285 83.4114 79.9768 83.7196 79.9768 84.0998V93.271C79.9768 93.6512 80.285 93.9595 80.6652 93.9595H94.2893C94.8963 93.9595 95.2062 93.2311 94.7854 92.7937Z",
    fill: "#18252C"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "thumbnail-train-front",
    cx: 83.163,
    cy: 74.4456,
    rx: 10.0206,
    ry: 9.55818,
    transform: "rotate(90 83.163 74.4456)",
    fill: "#F75322"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "thumbnail-train-engine-shadow",
    x: 55.5505,
    y: 64.4249,
    width: 28.6745,
    height: 20.0413,
    fill: "#F97953"
  }), /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-train-door",
    d: "M33.5222 52.8221H56.6125V84.4662H29L29 80.7836C29 78.7409 30.6559 77.085 32.6987 77.085H33.5222V68.6441V52.8221Z",
    fill: "#EA462F"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "thumbnail-train-detail",
    x: 31.7939,
    y: 51.008,
    width: 26.4876,
    height: 2.73326,
    rx: 0.809765,
    fill: "#18252C"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "thumbnail-train-window",
    x: 36.4343,
    y: 55.9865,
    width: 16.9923,
    height: 14.7673,
    rx: 0.809765,
    fill: "#A4D0DA"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "thumbnail-train-detail",
    x: 35.406,
    y: 72.7032,
    width: 5.50391,
    height: 1.70829,
    rx: 0.809765,
    fill: "#18252C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.5615,
    y: 66.0409,
    width: 27.6916,
    height: 5.46652,
    fill: "#FA9F84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-train-wheel",
    d: "M54.0136 84.9174C54.0136 89.7836 50.0399 93.7401 45.1237 93.7401C40.2076 93.7401 36.2339 89.7836 36.2339 84.9174C36.2339 80.0512 40.2076 76.0948 45.1237 76.0948C50.0399 76.0948 54.0136 80.0512 54.0136 84.9174Z",
    fill: "#9DA4AF",
    stroke: "#18252C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-train-wheel",
    d: "M68.2865 88.3326C68.2865 91.311 65.8536 93.7372 62.8381 93.7372C59.8226 93.7372 57.3896 91.311 57.3896 88.3326C57.3896 85.3541 59.8226 82.9279 62.8381 82.9279C65.8536 82.9279 68.2865 85.3541 68.2865 88.3326Z",
    fill: "#9DA4AF",
    stroke: "#18252C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-train-wheel",
    d: "M82.9088 88.3326C82.9088 91.311 80.4759 93.7372 77.4604 93.7372C74.4449 93.7372 72.012 91.311 72.012 88.3326C72.012 85.3541 74.4449 82.9279 77.4604 82.9279C80.4759 82.9279 82.9088 85.3541 82.9088 88.3326Z",
    fill: "#9DA4AF",
    stroke: "#18252C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-train-detail",
    d: "M67.3486 54.6901C67.3768 54.5363 67.5108 54.4245 67.6672 54.4245H77.4471C77.6035 54.4245 77.7375 54.5363 77.7657 54.6901L77.9911 55.9214C78.0275 56.1204 77.8747 56.3036 77.6725 56.3036H67.4418C67.2396 56.3036 67.0868 56.1204 67.1232 55.9214L67.3486 54.6901Z",
    fill: "#18252C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_78126",
    x: 6.08504,
    y: 6.4257,
    width: 89.8089,
    height: 89.6868,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.457478
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.457478
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_78126"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_78126",
    result: "shape"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAmusementParkThumbnail);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/AmusementParkThumbnail.bfccd8b7163dde0020163672d6347a06.svg";